<script>
    import { Link } from "svelte-routing";
    import { onMount } from 'svelte';
    import { evaluate } from 'mathjs';  
    import { boyutList, gostergeList, formulList, degerList} from "../Api.svelte";
    import { degerlerStore } from '../stores/stores';
    import Footer from "components/Footers/Footer.svelte";
    
    
    let degerler = [];
    let gostergeler = [];
    let formuller = [];
    let boyutlar = [];
    let degerlerYil = {};
    let yilLength = 0;
    let years = [];
    let boyutAdi = [];
    let gostergeBoyutGrup = {};

    degerlerStore.subscribe(value => {
        degerler = value;
        groupDegerlerByYear();
    });
    
    function selectBoyutadi(id) {
        const boyutAdi = boyutlar.find(b => b._id === id)?.name;
        return boyutAdi;
    }
    
    function groupGostergelerByBoyut() {
        gostergeBoyutGrup = gostergeler.reduce((byt, gstr) => {
            const boyut = gstr.boyut_id;
            if (!byt[boyut]) {
                byt[boyut] = [];
            }
            byt[boyut].push(gstr);
            return byt;
        }, {});
        boyutAdi = Object.keys(gostergeBoyutGrup);
    }
    
    function groupDegerlerByYear() {
        degerlerYil = degerler.reduce((acc, deger) => {
            const year = deger.yil; 
            if (!acc[year]) {
                acc[year] = [];
            }
            acc[year].push(deger);
            return acc;
        }, {});
    
        // Yıl isimlerini al
        years = Object.keys(degerlerYil);
        // Yıl sayısını hesapla
        yilLength = years.length;
    }
    
    function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $&, eşleşen kısmı temsil eder.
}

function formulHesapla(g_id, veriler) {
        const formul = formuller.find(f => f.gosterge_id === g_id)?.formul;
        if (!formul) return false;
        // console.log(veriler);
        // console.log(formul);

        let hesaplananFormul = formul;

        // veriler birden fazla obje içeriyorsa her objeyi birleştir
        let combinedVeriler = veriler.reduce((acc, veri) => {
            return { ...acc, ...veri };
        }, {});

        // Değişkenleri string içinde değiştir
        for (const [key, value] of Object.entries(combinedVeriler)) {
            hesaplananFormul = hesaplananFormul.replace(new RegExp(`{${escapeRegExp(key)}}`, 'g'), value);
        }

        try {
            const result = evaluate(hesaplananFormul);
            return parseFloat(result.toFixed(2));
        } catch (e) {
            console.error(`Error evaluating formula: ${hesaplananFormul}`, e);
            return false;
        }
    }
    function guncelDate(degerler) {
    if (!degerler || degerler.length === 0) return '';

    // En büyük tarihi bul
    const latestDate = degerler.reduce((max, deger) => {
        const currentDate = new Date(deger.updated_at);
        return currentDate > max ? currentDate : max;
    }, new Date(degerler[0].updated_at));

    // Yıl, ay ve gün formatında döndür
    return latestDate.toISOString().split('T')[0];
}


    
    onMount(async () => {
        gostergeler = await gostergeList();
        gostergeler = [...gostergeler].reverse();
        degerler = await degerList();
        formuller = await formulList();
        boyutlar = await boyutList();
        groupDegerlerByYear();
        groupGostergelerByBoyut();
    });

    const tbodyColors = ["bg-red-110", "bg-blue-110", "bg-green-110"];
    const trColors = ["odd:bg-red-200", "odd:bg-blue-200", "odd:bg-green-200"];
    export let location;

    </script>
    
    <body>
        <div class="container mx-auto sticky top-0 mt-1 border-b border-gray-300 table1100">
            <div class="mx-auto flex items-center">
                <div class="w-full w-24 border border-r-0 rounded-l bg-red-700 text-center">
                    <a href="#">
                        <img src="https://uludag.edu.tr/img/yu.svg" class="mx-auto h-24">
                    </a>
                </div>
                <div class="w-full flex items-center justify-center bg-red-700 h-24">
                    <h2 class="text-white font-bold text-2xl">ARAŞTIRMA KAPASİTESİ BOYUTU GÖSTERGE TANIMLARI</h2>
                </div>
                <div class="w-full w-24 border border-l-0 rounded-r bg-white text-center">
                    <a href="#">
                        <img src="https://www.yok.gov.tr/_catalogs/masterpage/yok2018/assets/images/layout_set_logo-img_id=1520536731601.png" alt="Logo" class="mx-auto h-24">
                    </a>
                </div>
            </div>
        </div>
    
        <div class="container mx-auto mb-4 mt-1 table1100">
            <table class="text-left w-full ">
                <thead class="bg-black text-white w-full sticky z-10 top-24">
                    <tr>
                        <th class="px-4 py-2 border border-gray-300" rowspan="2">Boyut</th>
                        <th class="px-4 py-2 border border-gray-300" rowspan="2">Gösterge</th>
                        <th class="px-4 py-2 border border-gray-300" rowspan="2">Tanım</th>
                        <th class="px-4 py-2 border border-gray-300 text-center" colspan={`${yilLength}`}>Değer</th>
                        <th class="px-4 py-2 border border-gray-300" rowspan="2">Kaynak</th>
                        <th class="px-4 py-2 border border-gray-300" rowspan="2">Güncelleme Tarihi</th>
                    </tr>
                    <tr>
                        {#each years as yil}
                            <th class="px-4 py-2 border border-gray-300">{yil}</th>
                        {/each}
                    </tr>
                </thead>
                
                {#each Object.entries(gostergeBoyutGrup) as [boyut, gostergefor] ,ix}
                <tbody class={`items-center -z-10 justify-between w-full text-black border border-gray-500 ${tbodyColors[ix]}`}>
                    <!-- <tbody class=" items-center bg-blue-110 -z-10 justify-between w-full text-black  border border-gray-500   "> -->
                        {#each gostergefor as gosterge, index}
                            <tr class={`${trColors[ix]}`}>
                            <!-- <tr class="odd:bg-blue-200"> -->
                                {#if index === 0}
                                    <td class="px-4 py-2  border border-gray-500   font-bold vertical-lr rotated text-center" rowspan={gostergefor.length}>{selectBoyutadi(boyut)}</td>
                                {/if}
                                <td class="px-4 py-2 border border-gray-500   ">{gosterge.name}</td>
                                <td class="px-4 py-2 border border-gray-500   ">{gosterge.tanim}</td>
                                {#if gosterge.deger_sayisi == 1}
                                    {#each years as yil}
                                        {#if degerlerYil[yil].find(d => d.gosterge_id === gosterge._id)?.veriler}
                                            <td class="px-4 py-2  border border-gray-500   font-bold">
                                                {#each degerlerYil[yil].find(d => d.gosterge_id === gosterge._id).veriler as veri}
                                                    {Object.values(veri)}
                                                {/each}
                                            </td>
                                        {:else}
                                            <td class="px-4 py-2  border border-gray-500   font-bold"> 


                                                <div class="content-center">
                                                    <div class="border-gray-300  h-10 w-10 animate-spin rounded-full border-4 border-t-red-500" />
                                                </div>
                                            </td>
                                        {/if}
                                    {/each}
                                {:else}
                                    {#each years as yil}
                                        {#if degerlerYil[yil].find(d => d.gosterge_id === gosterge._id)?.veriler}
                                            <td class="px-4 py-2 border border-gray-500 font-bold">
                                                <div>

                                                    {#if formulHesapla(gosterge._id, degerlerYil[yil].find(d => d.gosterge_id === gosterge._id).veriler)}
                                                
                                                    {formulHesapla(gosterge._id, degerlerYil[yil].find(d => d.gosterge_id === gosterge._id).veriler)}
                                                    {:else}
                                                      <div class="content-center">
                                                        <div class="border-gray-300 h-10 w-10 animate-spin rounded-full border-4 border-t-red-500"></div>
                                                      </div>
                                                    {/if}
                                                  </div>
                                            </td>
                                        {:else}
                                            <td class="px-4 py-2  border border-gray-500   font-bold">
                                                <div class="content-center">
                                                    <div class="border-gray-300  h-10 w-10 animate-spin rounded-full border-4 border-t-red-500" />
                                                </div>
                                            </td>
                                        {/if}
                                    {/each}
                                {/if}
                                <td class="px-4 py-2 border border-gray-500   ">{gosterge.kaynak}</td>
                                <!-- <td class="px-4 py-2 border border-gray-500   ">{gosterge.updated_at}</td> -->
                                <td class="px-4 py-2 border  border-gray-500   ">
                                    { guncelDate(Object.values(degerlerYil).flat().filter(d => d.gosterge_id === gosterge._id))}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                {/each}
            </table>
        </div>
    </body>
    <Footer />
    